import { render, staticRenderFns } from "./lianhetiHeader.vue?vue&type=template&id=61325752&scoped=true"
import script from "./lianhetiHeader.vue?vue&type=script&lang=js"
export * from "./lianhetiHeader.vue?vue&type=script&lang=js"
import style0 from "./lianhetiHeader.vue?vue&type=style&index=0&id=61325752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61325752",
  null
  
)

export default component.exports